<template>
  <div class="doc">
    <yu-head/>
    <div class="container">
      <yu-menu/>
      <yu-article>
        <div class="phone">
          <iframe src="http://mobileweb.yurencloud.com/#/checkbox" frameborder="0" width="320" height="580"></iframe>
        </div>


        <div class="title">复选框</div>
        <div class="sub-title">普通用法</div>

        <pre v-highlightjs="code1"><code class="html" ></code></pre>
        <pre v-highlightjs="code2"><code class="javascript" ></code></pre>

        <div class="sub-title">禁止选项</div>
        <pre v-highlightjs="code3"><code class="javascript" ></code></pre>

        <div class="sub-title">禁止全部</div>
        <pre v-highlightjs="code4"><code class="html" ></code></pre>

        <div class="sub-title">列表外部选项</div>
        <pre v-highlightjs="code5"><code class="html" ></code></pre>

        <div class="sub-title">属性</div>
        <yu-table :data="attributes1" :widths="widths1"/>

        <div class="sub-title">事件</div>
        <yu-table :data="attributes2" :widths="widths2"/>

      </yu-article>
    </div>
  </div>
</template>

<script>
import { YuTable } from 'yu.ui';
import { YuButton, YuText } from 'yu.mobile';
import YuHead from './yu-head';
import YuMenu from './yu-menu';
import YuArticle from './yu-article';

export default {
  name: 'Buttons',
  data() {
    return {
      code1: `
 <yu-checkbox name="a" :options="options"/>
      `,
      code2: `
  import { YuCheckbox } from 'yu.mobile';

  export default {
    name: 'checkbox',
    data() {
      return {
        options: [
          { value: 0, label: '博士', description: '正经的', checked: false },
          { value: 1, label: '本科', checked: false },
          { value: 2, label: '高中', checked: false },
        ],
      }
    },
    components: {
      YuCheckbox,
    },
  };
      `,
      code3: `
 { value: 1, label: '本科', checked: false, disabled: true },
      `,
      code4: `
 <yu-checkbox name="a" :options="options" disabled/>
      `,
      code5: `
 <yu-checkbox name="d" :options="options4" bottom>
    <span slot="footer">我已经阅读 <a href="">协议</a></span>
 </yu-checkbox>
      `,
      attributes1: [
        {
          prop: '参数',
          description: '说明',
          types: '类型',
          default: '默认值',
        },
        {
          prop: 'options',
          description: '复选框选项',
          types: 'Array',
          default: '无',
        },
        {
          prop: 'value',
          description: '复选框input的值',
          types: 'String',
          default: '无',
        },
        {
          prop: 'name',
          description: '每个复选框input的名',
          types: 'String',
          default: '无',
        },
        {
          prop: 'disabled',
          description: '禁用全部复选框',
          types: 'Boolean',
          default: '无',
        },
        {
          prop: 'bottom',
          description: '列表外的底部复选框',
          types: 'Boolean',
          default: '无',
        },
      ],
      attributes2: [
        {
          event: '事件名称',
          description: '说明',
          callback: '回调参数',
        },
        {
          event: 'click',
          description: '触发选项点击事件',
          callback: '( event: Event )',
        },
        {
          event: 'change',
          description: '触发change事件',
          callback: '( values: Object, name: String, checked: Boolean )',
        },
      ],
      widths1: {
        prop: '150px',
        description: '300px',
        types: '120px',
        default: '200px',
      },
      widths2: {
        event: '150px',
        description: '300px',
        callback: '320px',
      },
    };
  },
  components: {
    YuHead,
    YuMenu,
    YuArticle,
    YuTable,
    YuButton,
    YuText,
  },
};
</script>

<style lang="scss" scoped type="text/scss">
  @import "../assets/css/varible";

  .doc {
    color: $text;
    height: 100%;
    .container {
      width: 1200px;
      margin: 30px auto;
      .title {
        color: $text;
        font-weight: bold;
        padding: 14px 0;
        margin: 20px 0;
        border-bottom: 1px solid $border;
      }
      .sub-title {
        color: $text;
        padding: 0 8px;
        margin: 20px 0;
        border-left: 4px solid $primary;
      }
    }

    .phone{
      text-align: center;
      iframe {
        margin: 20px auto;
        border-radius: 20px;
        &::-webkit-scrollbar {
          width: 0;
        }
        border: 10px solid $border;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/checkbox.vue